
import React from 'react';
import AdminLayout from '@/components/admin/AdminLayout';

const AdminPrivilegesPage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Admin Privileges</h1>
        <p className="mt-4">Manage admin privileges.</p>
      </div>
    </AdminLayout>
  );
};

export default AdminPrivilegesPage;
